import { useCallback } from 'react';
import { Link } from 'react-router-dom';

import { PageHeader } from '../../../../components/PageHeader';
import { Pagination } from '../../../../components/pagination/Pagination';
import { ITableHeader, Table } from '../../../../components/table/Table';
import { getIncomingOrders } from '../../models';
import { IPaginationVariables, usePagination } from '../../../../hooks/usePagination';
import { formatDateTime } from '../../../../utils/date';
import { PageHeading } from 'components/PageHeading';
import { Breadcrumb } from 'components/Breadcrumb';
import { ListPage } from 'components/page-templates/ListPage';

const ORDERS_HEADERS: ITableHeader[] = [
  {
    id: 'orderId',
    name: 'Order Nr',
  },
  {
    id: 'subject',
    name: 'Onderwerp',
  },
  {
    id: 'from',
    name: 'Van',
  },
  {
    id: 'receivedAt',
    name: 'Ontvangen op',
  },
  {
    id: 'startedProcessingAt',
    name: 'Verwerking gestart op',
  },
  {
    id: 'isProcessed',
    name: 'Is verwerkt?',
  },
];

const IncomingOrdersPage = () => {
  const pageFetcher = useCallback(async (variables: IPaginationVariables) => {
    const result = await getIncomingOrders(variables.cursor, variables.take);
    return result.incomingOrders;
  }, []);
  const page = usePagination({
    key: 'id',
    pageSize: 50,
    initialCursor: undefined,
    fetcher: pageFetcher,
  });

  return (
    <>
      <PageHeader title="Orders" />

      <ListPage
        heading={<PageHeading noMarginBottom leftSide={<Breadcrumb currentItem="Binnengekomen Orders" />} />}
        filters={<h2>Ingekomen Emails</h2>}
        pagination={
          <Pagination
            hasPrevious={page.hasPrevious}
            previous={page.previous}
            hasNext={page.hasNext}
            next={page.next}
            isFetching={page.isFetching}
          />
        }
      >
        <Table
          className="h-full"
          idKey="id"
          headers={ORDERS_HEADERS}
          data={page.data}
          error={page.error}
          onRetry={page.retry}
          isLoading={page.isFetching}
          mapData={(orderEmail) => {
            const subject = orderEmail.subject.trim();

            return [
              orderEmail.order ? (
                <Link to={`../${orderEmail.order.id}/general`} className="link-text whitespace-nowrap">
                  {orderEmail.order.orderNumber ?? 'DRAFT'}
                </Link>
              ) : (
                'Geen order'
              ),
              <Link to={`${orderEmail.id}`} className="link-text whitespace-nowrap">
                {subject || 'Geen onderwerp'}
              </Link>,
              orderEmail.from,
              formatDateTime(orderEmail.receivedAt),
              formatDateTime(orderEmail.startedProcessingAt),
              orderEmail.isProcessed ? 'Ja' : 'Neen',
            ];
          }}
        />
      </ListPage>
    </>
  );
};

export default IncomingOrdersPage;
